import { LogLevel } from './types';

export type EluveErrorArgs = {
  error?: Error;
  metadata?: Record<string, unknown>;
};

export abstract class EluveError extends Error {
  abstract override readonly name: string;
  abstract readonly logLevel: LogLevel;
  readonly cause?: Error;
  readonly metadata?: Record<string, unknown>;

  constructor(message: string, args?: EluveErrorArgs) {
    const cause = args?.error;
    const metadata = args?.metadata;
    super(message);
    this.cause = cause;
    this.metadata = metadata;
  }

  getLogDetails = () => {
    return {
      name: this.name,
      errorMessage: this.cause?.message,
      stack: this.cause?.stack,
      message: this.message,
      metadata: this.metadata,
    };
  };
}
